'use client';

import { FeatureViewed } from '@ria-client/segment/components/FeatureViewed';
import type { FinancialAdvisorsSummaryTableEntityType } from '@ria-client/supergraph/structuredContent/hydration/FinancialAdvisorsSummaryTable/types';
import { Table } from '@ria-client/tw-shadcn/components/table';
import { ScrollableRegion } from '@ria-client/tw-shared-ui/layout/scrollable-region';
import { SummaryTableBody } from './financial-advisors-summary-table/table-body';
import { SummaryTableHeader } from './financial-advisors-summary-table/table-header';
import { resolveDrivers } from './lib/financial-advisors/drivers';
import type { DriverConfig } from './lib/financial-advisors/types';

export interface FinancialAdvisorsSummaryTableProps {
  marketplaceEntities: FinancialAdvisorsSummaryTableEntityType[];
  showBestForLabel?: boolean;
  displayAdLabel?: boolean;
  monetizingCtaLabel?: string;
  starRatingTooltip?: string;
  firstDriver?: DriverConfig;
  secondDriver?: DriverConfig;
  thirdDriver?: DriverConfig;
}

export function FinancialAdvisorsSummaryTable({
  props,
}: {
  props: FinancialAdvisorsSummaryTableProps;
}): React.JSX.Element {
  const {
    marketplaceEntities,
    firstDriver,
    secondDriver,
    thirdDriver,
    starRatingTooltip,
    displayAdLabel,
    monetizingCtaLabel,
  } = props;
  const drivers = resolveDrivers(firstDriver, secondDriver, thirdDriver);

  return (
    <FeatureViewed entityName="financial_advisors_summary_table" entitySection="structured_content">
      <div>
        <ScrollableRegion
          aria-label="Financial advisor summary table"
          className="md:overflow-x-visible"
        >
          <Table className="border-collapse border-spacing-0">
            <SummaryTableHeader drivers={drivers} starRatingTooltip={starRatingTooltip} />
            <SummaryTableBody
              displayAdLabel={displayAdLabel}
              drivers={drivers}
              marketplaceEntities={marketplaceEntities}
              monetizingCtaLabel={monetizingCtaLabel}
            />
          </Table>
        </ScrollableRegion>
      </div>
    </FeatureViewed>
  );
}
